import AppState from "store/AppState";

export const selectProductGroupComponents = (state: AppState) =>
  state.productGroupComponents.components;

export const selectProductGroupComponentsProductIds = (state: AppState) =>
  state.productGroupComponents.components.map(
    (product) => product.productId,
  );

export const selectProductGroupComponentsLoading = (state: AppState) =>
  state.productGroupComponents.loading;